import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-header',
  templateUrl: './contact-header.component.html',
  styleUrls: ['./contact-header.component.less']
})
export class ContactHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
